import type { Project } from '@/types';

/**
 * Projects listed in Muhammad_Sufyan_Malik.pdf under Professional / Academic Projects.
 * Live and repository URLs were not present in the CV — add them when available.
 */
export const projects: Project[] = [
  {
    id: 'servisim',
    title: 'Servisim',
    shortDescription: 'Android service app with maps, notifications, and REST integration.',
    detailedDescription:
      'Android application built with Java, Retrofit, MVP, Material Design, push notifications, map integration, and JSON APIs.',
    technologies: [
      'Java',
      'Android Studio',
      'XML',
      'Retrofit',
      'MVP',
      'Material Design',
      'Push Notifications',
      'Maps',
      'JSON',
    ],
    category: 'Mobile',
    featured: true,
    status: 'completed',
  },
  {
    id: 'dr-pakistan',
    title: 'Dr. Pakistan',
    shortDescription: 'Android healthcare-oriented app with notifications and MySQL-backed data.',
    detailedDescription:
      'Android application using Java, XML, Volley, Material Design, notifications, and a MySQL database.',
    technologies: [
      'Java',
      'Android Studio',
      'XML',
      'Volley',
      'Material Design',
      'Notifications',
      'MySQL',
    ],
    category: 'Mobile',
    featured: true,
    status: 'completed',
  },
  {
    id: 'theksaff',
    title: 'TheKsaff',
    shortDescription: 'Android app with Firebase authentication and notifications.',
    detailedDescription:
      'Android application featuring Firebase login/signup flows and notification support.',
    technologies: ['Java', 'Android Studio', 'Firebase', 'Notifications'],
    category: 'Mobile',
    featured: false,
    status: 'completed',
  },
  {
    id: 'play-learn',
    title: 'Play Learn App',
    shortDescription: 'Educational Android app with Material Design and animations.',
    detailedDescription:
      'Android learning application built with Java, Material Design, and animations.',
    technologies: ['Java', 'Android Studio', 'Material Design', 'Animations'],
    category: 'Mobile',
    featured: false,
    status: 'completed',
  },
  {
    id: 'smart-home',
    title: 'Smart Home App',
    shortDescription: 'Android smart-home client using HTTP requests.',
    detailedDescription:
      'Android application for smart-home interactions built with Java, XML, and HTTP requests.',
    technologies: ['Java', 'Android Studio', 'XML', 'HTTP'],
    category: 'Mobile',
    featured: false,
    status: 'completed',
  },
  {
    id: 'chicken-islamabad-pos',
    title: 'Chicken Islamabad Shop POS',
    shortDescription: 'Point-of-sale desktop application built with C#.',
    detailedDescription: 'Desktop POS system developed in C# with Visual Studio.',
    technologies: ['C#', 'Visual Studio'],
    category: 'Desktop',
    featured: false,
    status: 'completed',
  },
  {
    id: 'colorimetric-analysis',
    title: 'Colorimetric Analysis',
    shortDescription: 'Final-year Android app for analysts and chemists.',
    detailedDescription:
      'Android application that captures or loads images, applies filters when needed, performs segmentation, and processes RGB data to measure intensity in a region of interest for laboratory analysis.',
    technologies: ['Java', 'Android'],
    category: 'Academic',
    featured: true,
    status: 'completed',
  },
  {
    id: 'cv-creator',
    title: 'CV Creator',
    shortDescription: 'Desktop CV creation utility built with C#.',
    detailedDescription: 'Academic/desktop project for creating CVs using C#.',
    technologies: ['C#'],
    category: 'Desktop',
    featured: false,
    status: 'completed',
  },
  {
    id: 'clinic-online',
    title: 'Clinic Online Website',
    shortDescription: 'Clinic website built with HTML, CSS, and PHP.',
    detailedDescription: 'Academic web project for an online clinic presence.',
    technologies: ['HTML', 'CSS', 'PHP'],
    category: 'Web',
    featured: false,
    status: 'completed',
  },
  {
    id: 'ecommerce-store',
    title: 'Online Shopping Store',
    shortDescription: 'E-commerce website project.',
    detailedDescription: 'Academic e-commerce storefront project listed in the CV.',
    technologies: ['HTML', 'CSS', 'PHP'],
    category: 'Web',
    featured: false,
    status: 'completed',
    // TODO: Confirm exact stack details if you want them listed more precisely.
  },
];

/** Projects safe to render in the UI (excludes placeholders). */
export const publishedProjects = projects.filter((project) => !project.isPlaceholder);
